import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "wrapper-facility-abstract" }
const _hoisted_2 = { class: "sticky" }
const _hoisted_3 = {
  key: 2,
  class: "points-list q-ma-none"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "q-mb-none" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Блоки:")
], -1)

import { storeToRefs } from 'pinia';
import {
  ref, watch, getCurrentInstance, onMounted, nextTick,
} from 'vue';
import { useDivisionStore } from '~store/division/divisionModule';
import FacilityAbstract from '@/components/facility/FacilityAbstract.vue';
import PointItem from '@/components/facility/PointItem.vue';
import { Facility } from './types';

interface Props {
  data?: Facility[],
  deep: number[],
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FacilityAbstractWidget',
  setup(__props) {

const divisionStore = useDivisionStore();
const { points, facilityNodesState, facilityMock } = storeToRefs(divisionStore);
const instance = getCurrentInstance();

onMounted(async () => {
  const parent: any = instance?.parent?.proxy;
  const current: any = instance?.parent;
  console.log(parent, current);
  await nextTick();
  // console.log(parent.calcColWidth(0, 0));
  // console.log(parent.calcWH(parent));
});

const nodeName = (node: any) => node?.name ?? '';
/* eslint-disable no-unused-expressions */
// eslint-disable-next-line consistent-return
const relevantIcon = (key: string) => {
  switch (key) {
    case 'subjectRF': return 'location_city';
    case 'district': return 'near_me';
    case 'address': return 'location_on';
    case 'building': return 'home';
    case 'number_space': return 'space_dashboard';
    case 'point': return 'radio_button_checked';
    default: '';
  }
};
const isSomeSelected = ref(false);
watch(
  () => facilityNodesState.value,
  () => {
    isSomeSelected.value = Object.values(facilityNodesState).some((i) => !!i);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (isSomeSelected.value)
        ? (_openBlock(), _createBlock(_component_q_breadcrumbs, {
            key: 0,
            class: "text-black q-px-md",
            "active-color": "black"
          }, {
            separator: _withCtx(() => [
              _createVNode(_component_q_icon, {
                size: "1.5em",
                name: "chevron_right",
                color: "black"
              })
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(facilityNodesState), (value, key) => {
                return (_openBlock(), _createBlock(_component_q_breadcrumbs_el, {
                  key: key,
                  label: nodeName(value),
                  icon: relevantIcon(key)
                }, {
                  default: _withCtx(() => [
                    value
                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value.tooltip), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["label", "icon"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (isSomeSelected.value && _unref(points))
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 1,
            inset: "",
            class: "q-my-xs"
          }))
        : _createCommentVNode("", true),
      (_unref(points))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(points), (point) => {
              return (_openBlock(), _createBlock(PointItem, {
                key: point.id_point,
                point: point
              }, null, 8, ["point"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (isSomeSelected.value || _unref(points))
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 3,
            inset: "",
            class: "q-my-xs"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(FacilityAbstract, { data: _unref(facilityMock) }, null, 8, ["data"])
  ]))
}
}

})